import { ApiUrl } from "../../../../assets/data/TkApiUrlProperty";
import http from "../../../../services/http";
import {
  IAPI_REC016_Request,
  IAPI_REC016_Response,
} from "../../../../type/apiType";

const httpGetClaimList = async (
  params: IAPI_REC016_Request
): Promise<IAPI_REC016_Response> => {
  const res = await http.post(`${ApiUrl.API_REC016}`, params);
  return res.data;
};

export { httpGetClaimList };
